import { CustomThemeOptions } from '../themeTypes';

export default {
  custom: {
    pages: {
      login: {
        hideDirections: true,
      },
    },
  },
  typography: {
    h1: {
      alignSelf: 'flex-start',
      color: '#b3bdfa',
      fontSize: 36,
      fontWeight: 200,
      textAlign: 'left',
    },
    subtitle1: {
      fontSize: 14,
      color: '#fff',
      alignSelf: 'flex-start',
      textAlign: 'left',
    },
    body2: {
      marginTop: 0,
      color: '#fff',
    },
  },
  props: {
    MuiLink: {
      underline: 'always',
    },
    MuiButton: {
      fullWidth: false,
    },
    MuiGrid: {
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
  },
  overrides: {
    MuiButton: {
      contained: {
        height: 46,
        fontSize: 18,
        fontWeight: 400,
        textTransform: 'none',
        '&:focus': {
          '&::before': {
            display: 'none',
          },
        },
      },
      containedPrimary: {
        background: 'linear-gradient(to bottom, #5dc356, #48ac43)',
        '&:hover': {
          background: 'linear-gradient(to bottom, #44aa3d, #2f932a)',
        },
        marginRight: 'auto',
      },
    },
    MuiLink: {
      root: {
        marginLeft: 10,
        color: '#fff',
        '&:hover': {
          color: '#e6e6e6',
        },
      },
    },
    MuiInputLabel: {
      root: {
        color: '#fff',
      },
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: '#fff',
        height: 34,
        '&$focused $notchedOutline': {
          borderColor: 'rgba(82, 169, 236, 0.8)',
          boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(82, 169, 236, 0.6)',
        },
      },
      input: {
        padding: '0 8px',
        '&:-webkit-autofill': {
          padding: '9px 8px',
        },
      },
    },
    MuiAlert: {
      standardError: {
        color: '#d61e3e',
        backgroundColor: '#faecec',
        borderLeftColor: '#d61e3e',
      },
    },
    MuiCard: {
      root: {
        borderColor: '#ecae00',
        borderWidth: 2,
        borderStyle: 'solid',
        backgroundColor: '#fffae2',
        color: '#dd9f00',
      },
    },
  },
} as CustomThemeOptions;
